<template>
  <div>
    <div class="group-tree_title">
      <div class="group-tree-title_content">
        {{ $l("title_user_group") || "人员分组" }}
      </div>
      <el-button
        v-if="allow('S')"
        type="primary"
        size="small"
        @click="onSyncUser()"
        >{{ $l("btn_sync_user") || "同步生产线人员" }}</el-button
      >
    </div>

    <div
      :style="{
        height: contentHeight - 42 + 'px',
      }"
      style="overflow: auto;padding: 0 10px;"
    >
      <el-tree
        ref="userGroupTree"
        :data="dataSource"
        highlight-current
        node-key="subgroupCode"
        class="personnel-group-tree"
        :props="{ class: '' }"
        default-expand-all
        :expand-on-click-node="false"
        @node-click="clickNode"
        v-loading="loading"
      >
        <template slot-scope="{ node, data }">
          <span class="custom-tree-node">
            <i
              class="fa fa-file-o mr-10px"
              style="font-size: 18px;"
              v-if="!data.iconUrl"
            ></i>
            <img
              :src="data.iconUrl"
              v-else-if="data.iconUrl && data.iconUrl.startsWith('http')"
              class="mr-10px icon"
              :class="{
                'icon-top': data.isTop == 'Y',
              }"
            />
            <!-- <Icon v-else :name="data.iconUrl" class="mr-10px font-size-20px" /> -->
            <TreeTagText
              :content="data.subgroupName"
              v-if="data.subgroupName"
            />
            <div @click.stop>
              <el-dropdown
                trigger="click"
                @command="(e) => onCommand(e, data, node)"
                placement="bottom-end"
              >
                <span class="toolbar-icon">
                  <i class="el-icon-more"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="data.isLast != 'Y' && allow('B')"
                    command="add"
                    >{{
                      $l("tree_menu_add_group") || "新增分组"
                    }}</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="data.isTop != 'Y' && allow('C')"
                    command="edit"
                  >
                    {{
                      $l("tree_menu_edit_group") || "编辑分组"
                    }}</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="!data.children && data.isTop != 'Y' && allow('E')"
                    command="remove"
                  >
                    {{
                      $l("tree_menu_del_group") || "删除分组"
                    }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </span>
        </template>
      </el-tree>
      <AddGroupForm
        @reload="loadData"
        :visible.sync="addGroupFormOption.visible"
        :subgroupCode="addGroupFormOption.subgroupCode"
        :type="addGroupFormOption.type"
        :levelNo="addGroupFormOption.levelNo"
      ></AddGroupForm>
    </div>
  </div>
</template>

<script>
import AddGroupForm from "../AddGroupForm/index.vue";
import TreeTagText from "./TreeTagText.vue";
import EditLoading from "@/mixins/edit-loading";

export default {
  name: "GroupTree",
  mixins: [EditLoading],
  components: {
    AddGroupForm,
    TreeTagText,
  },
  props: {
    contentHeight: {
      type: Number,
      default: 600,
    },
  },
  inject: ["group-current-row", "group-content-height"],
  data() {
    return {
      dataSource: [],
      userGroupTree: null,
      loading: false,
      currentRow: {},
      setCurrentRow: () => {},
      addGroupFormOption: {
        type: "add",
        visible: false,
        subgroupCode: "",
        levelNo: 1,
      },
    };
  },
  created() {
    if (this["group-current-row"]) {
      this.setCurrentRow = this["group-current-row"].setCurrentRow;
      this.currentRow = this["group-current-row"].currentRow;
    }
  },
  methods: {
    onCommand(e, data, node) {
      switch (e) {
        case "add":
          this.append(data, node);
          break;
        case "edit":
          this.edit(data, node);
          break;
        case "remove":
          this.remove(data, node);
          break;
      }
    },
    async onSyncUser() {
      const confirm = await this.$confirm(
        this.$l("message_sync_dep_user_record") || "确认要同步生产线人员吗？",
        this.$l("INDEX.tips_title_confirm") || "确认信息",
        {
          type: "warning",
          draggable: true,
          cancelButtonText: this.$l("INDEX.btn_cancel") || "取消",
          confirmButtonText: this.$l("INDEX.btn_confirm") || "确认",
        }
      )
        .then(() => true)
        .catch(() => false);
      if (!confirm) return;
      if (this.loadingOpen()) return;
      const res = await this.$api
        .factoryMemberSyncUserApi({})
        .catch(() => null);
      this.loadingClose();

      if (!res) return;
      const { status, msg } = res;
      const isWarning = status !== 200;
      this.$message({
        showClose: true,
        message: msg,
        type: isWarning ? "warning" : "success",
      });
      if (isWarning) return;
      this.loadData();
    },
    append(data) {
      this.addGroupFormOption.subgroupCode = data.subgroupCode;
      this.addGroupFormOption.levelNo = data.levelNo;
      this.addGroupFormOption.type = "add";
      this.addGroupFormOption.visible = true;
    },
    edit(data) {
      this.addGroupFormOption.subgroupCode = data.subgroupCode;
      this.addGroupFormOption.levelNo = data.levelNo;
      this.addGroupFormOption.type = "edit";
      this.addGroupFormOption.visible = true;
    },
    async remove(data) {
      const confirm = await this.$confirm(
        this.$l("message_del_this_group") || "确认要删除选择的分组吗？",
        this.$l("INDEX.tips_title_confirm") || "确认信息",
        {
          type: "warning",
          cancelButtonText: this.$l("INDEX.btn_cancel") || "取消",
          confirmButtonText: this.$l("INDEX.btn_confirm") || "确认",
        }
      ).catch(() => false);
      if (!confirm) return;
      const res = await this.$api.factoryMrpSubgroupDelApi({
        subgroupCode: data.subgroupCode,
      });
      if (!res) return;
      const { status, msg } = res;
      this.$message({
        showClose: true,
        message: msg,
        type: status !== 200 ? "warning" : "success",
      });
      if (status === 200) this.loadData();
    },
    clickNode(data) {
      this.setCurrentRow(data);
    },
    loadData() {
      this.loading = true;
      this.$api
        .factoryMrpSubgroupTreeApi()
        .then((res) => {
          this.loading = false;
          this.dataSource = res.body?.data || [];
          this.$nextTick(() => {
            if (this.dataSource && this.dataSource.length) {
              this.$refs.userGroupTree.setCurrentKey(
                this.dataSource[0].subgroupCode
              );
              this.clickNode(this.dataSource[0]);
            }
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>
<style lang="scss" scoped>
.mr-10px {
  margin-right: 10px;
}
.toolbar-icon {
  width: 32px;
  height: 32px;
  font-size: 20px;
  color: #bbbbbb;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  cursor: pointer;
}
.toolbar-icon:first-child {
  margin-left: 0px;
}
.toolbar-icon:hover {
  color: #007bff;
  background-color: #e7f1fe;
}
.group-tree_title {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding-right: 10px;
  height: 42px;
  margin-top: 10px;
  padding-bottom: 10px;
  justify-content: space-between;
}
.group-tree-title_content {
  font-size: 18px;
  --un-text-opacity: 1;
  color: rgb(7 20 55 / var(--un-text-opacity));
  font-weight: 600;
  margin-left: 10px;
}
.icon {
  width: 18px;
  height: 18px;
}
.icon-top {
  width: 20px;
  height: 20px;
}
</style>
<style>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  overflow: auto;
}
.personnel-group-tree > .el-tree-node > .el-tree-node__content {
  height: 35px !important;
  padding-top: 5px;
  padding-bottom: 5px;
}
.personnel-group-tree .el-tree-node__content {
  height: 35px !important;
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>
